// 菜单列表
const menuList = [
  {
    "id": "1067246875800000035",
    "pid": "0",
    "isAuth": true,
    "children": [
        {
          "id": "1067246875800000055",
          "pid": "1067246875800000035",
          "name": "资产概况",
          "url": "/acco-query/asset-overview",
          "icon": null,
          "isAuth": true
        },
        {
          "id": "1067246875800000007",
          "pid": "1067246875800000035",
          "name": "资产明细",
          "url": "/acco-query/asset-detail",
          "icon": null,
          "isAuth": true
        },
        {
          "id": "1067246875800000025",
          "pid": "1067246875800000035",
          "name": "账户资料",
          "url": "/acco-query/acco-info",
          "icon": null,
          "isAuth": true
        },
        {
          "id": "1067246875800000099",
          "pid": "1067246875800000035",
          "name": "银行卡管理",
          "url": "/acco-query/bank-mng",
          "icon": null,
          "isAuth": true
        },
        {
          "id": "1067246875800000006",
          "pid": "1067246875800000035",
          "name": "密码管理",
          "url": "/acco-query/psw-mng",
          "icon": null,
          "isAuth": true
        }
    ],
    "name": "我的账户",
    "url": null,
    "icon": "nwt-icon-daohang-wodezhanghu",
  },
  {
    "id": "21",
    "pid": "0",
    "isAuth":true,
    "children": [
      // {
      //   "id": "28",
      //   "pid": "21",
      //   "name":  window.config.cjxjb.name,
      //   "url": "/fund-trans/super-xjb/super-xjb",
      //   "icon": null,
      //   "isAuth": window.config.cjxjb.enable,
      // },
      {
        "id": "22",
        "pid": "21",
        "name": "买入",
        "url": "/fund-trans/subscribe",
        "icon": null,
        "isAuth": true
      },
      {
        "id": "23",
        "pid": "21",
        "name": "赎回",
        "url": "/fund-trans/redemption",
        "icon": null,
        "isAuth": true
      },
      // {
      //   "id": "24",
      //   "pid": "21",
      //   "children": [],
      //   "name": "转换",
      //   "url": "/fund-trans/transform",
      //   "icon": null,
      //   "isAuth": true
      // },
      {
        "id": "25",
        "pid": "21",
        "children": [],
        "name": "修改分红方式",
        "url": "/fund-trans/bonus",
        "icon": null,
        "isAuth": true
      },
      {
        "id": "26",
        "pid": "21",
        "children": [],
        "name": "撤单",
        "url": "/fund-trans/cancle",
        "icon": null,
        "isAuth": true
      },
      // {
      //   "id": "27",
      //   "pid": "21",
      //   "children": [],
      //   "name": "我的定投",
      //   "url": "/fund-trans/fixed-trans",
      //   "icon": null,
      //   "isAuth": true
      // }
    ],
    "name": "基金交易",
    "url": null,
    "icon": "nwt-icon-daohang-jijinjiaoyi",
  },
  {
    "id": "56",
    "pid": "0",
    "isAuth": true,
    "children": [
      {
        "id": "51",
        "pid": "56",
        "name": "基金交易查询",
        "url": "/my-acco/trade-query",
        "icon": null,
        "isAuth": true
      },
      {
        "id": "52",
        "pid": "56",
        "name": "分红查询",
        "url": "/my-acco/bonus-query",
        "icon": null,
        "isAuth": true
      },
      // {
      //   "id": "53",
      //   "pid": "56",
      //   "children": [],
      //   "name": "电子对账单",
      //   "url": "/my-acco/bill-query",
      //   "icon": null
      // }
    ],
    "name": "账户查询",
    "url": null,
    "icon": "nwt-icon-daohang-zhanghuchaxun"
  },
  {
    "id": "57",
    "pid": "0",
    "children": [
      {
        "id": "571",
        "pid": "57",
        "name": "我的专户",
        "url": "/special-acco/my-account",
        "icon": null,
        "isAuth": true
      },
      {
        "id": "572",
        "pid": "57",
        "name": "交易查询",
        "url": "/special-acco/trade-query",
        "icon": null,
        "isAuth": true
      },
      {
        "id": "573",
        "pid": "57",
        "name": "分红查询",
        "url": "/special-acco/bonus-query",
        "icon": null,
        "isAuth": true
      },
      {
        "id": "574",
        "pid": "57",
        "name": "净值查询",
        "url": "/special-acco/netvalue-query",
        "icon": null,
        "isAuth": true
      },
      {
        "id": "575",
        "pid": "57",
        "name": "信息披露",
        "url": "/special-acco/disclosure-query",
        "icon": null,
        "isAuth": true
      },
      // {
      //   "id": "53",
      //   "pid": "56",
      //   "children": [],
      //   "name": "电子对账单",
      //   "url": "/my-acco/bill-query",
      //   "icon": null
      // }
    ],
    "name": "专户交易",
    "url": null,
    "isAuth": window.config.zhuanhu.enable,
    "icon": "nwt-icon-zhuanhu"
  }
]

// 纯代销和机构户需要过滤的子菜单
const needFilterUrlList = ['/acco-query/acco-info','/acco-query/bank-mng','/fund-trans/redemption','/fund-trans/transform','/fund-trans/bonus','/fund-trans/cancle','/fund-trans/fixed-trans'];
// 纯代销和机构户需要过滤的一级菜单
const filterFirstMenuList = ['21'];

let initMenuList = menuList;


// 获取有权限的菜单列表
const filterMenuList = () => {
  // 筛选出有权限的一级菜单
  const firstMenu = menuList.filter(item => {
    let isOrgUser;
    const userInfo = JSON.parse(window.localStorage.getItem('userInfo'))?.user?.userInfo||'';
    if (userInfo.virtualUserFlag === '1') { // 1 为纯代销和机构户
      isOrgUser = true;
    }
    if (isOrgUser && filterFirstMenuList.includes(item.id))
      return false;
    return item.isAuth
  });

  // 筛选出有权限的二级菜单
  firstMenu.forEach(menuItem => {
    if (menuItem.children && menuItem.children.length > 0) {
      menuItem.children = filterChild(menuItem.children);
    }
  });
  return firstMenu;
};

const filterChild = (children) => {
  let notConsignAndOrgAuth;
  const userInfo = JSON.parse(window.localStorage.getItem('userInfo'))?.user?.userInfo||'';
  if (userInfo.virtualUserFlag !== '1') { // 1 为纯代销和机构户
    notConsignAndOrgAuth = true;
  }
  // 筛选出有权限的子菜单
  children.forEach(child => {
    // 纯代销和机构户 则不展示
    if (needFilterUrlList.includes(child.url)) {
      if (notConsignAndOrgAuth) {
        child.isAuth = true;
      } else {
        child.isAuth = false;
      }
    }
    // 超宝功能权限管控
    if (child.url == '/fund-trans/super-xjb/super-xjb') {
      if (window.config.cjxjb.enable && notConsignAndOrgAuth) {
        child.isAuth = true;
      } else {
        child.isAuth = false;
      }
    }
  });
  return children;
}

export {
  initMenuList,
  filterMenuList
}